import { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, query, where, onSnapshot } from "firebase/firestore";

export function useItem(slug) {
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!slug) {
      setItem(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    setItem(null); // Reset item state while loading new slug

    console.log(`Fetching item for slug: ${slug}`);
    const q = query(collection(db, "items"), where("slug", "==", slug));

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        if (!snapshot.empty) {
          const doc = snapshot.docs[0];
          console.log("Item found:", doc.id);
          setItem({ id: doc.id, ...doc.data() });
          setLoading(false);
        } else {
          console.log("Item not found for slug:", slug);
          setItem(null); // Item not found
          setError(new Error(`Article non trouvé pour le slug: ${slug}`));
          setLoading(false);
        }
      },
      (err) => {
        console.error("Error fetching item:", err);
        setError(err);
        setLoading(false);
        setItem(null);
      }
    );

    // Cleanup subscription on unmount or slug change
    return () => {
      console.log("Unsubscribing from item listener");
      unsubscribe();
    };
  }, [slug]); // Re-run effect if slug changes

  return { item, loading, error };
}
